module.exports = __webpack_public_path__ + "media/קיץ.6aeadb10.mp3";